module.exports = __webpack_public_path__ + "static/media/feTools-icon.9aae4129.png";